import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.unknown_view.title',
        defaultMessage: 'This is awkward, we ran into an error somewhere.'
    },
    description: {
        id: '_.unknown_view.description',
        defaultMessage:
            'Please call us on {phoneNumber}, and we’ll get it sorted for you.'
    },
    phoneNumber: {
        id: '_.unknown_view.phoneNumber',
        defaultMessage: '020 3778 0274'
    }
});
